// extracted by mini-css-extract-plugin
module.exports = {"row":"Row--styles-module_row-2Qdc9","col":"Row--styles-module_col-p0_H3"};